import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Table } from "semantic-ui-react";
import { toast } from "react-toastify";
import { getAuthHttpHeaders } from "../auth";
import { formatDateFromApi, formatDateTimeFromApi } from "../utils/dateTime";
import AddSimGroup from "./AddSimGroup";

@inject("store")
@observer
class SimGroups extends Component {
  state = {
    simGroups: null,
    addSimGroup: null,
    shortId: true,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get("sim/group/summaries");
      // console.log('exchangeAccount/list response', response);
      this.setState({ simGroups: response.data });
    } finally {
      this.setState({ loading: false });
    }
  };

  delete = async simGroup => {
    if (!window.confirm(`Are you sure you want to delete this SimGroup?`)) {
      return;
    }

    let axiosRequest = axios.create({
      baseURL: "api",
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      await axiosRequest.delete("sim/group/" + simGroup.id);
    } catch (e) {
      alert(e);
    } finally {
      this.load();
    }
  };

  migrateToInflux = async () => {
    if (!window.confirm(`Are you sure you want to start migration?`)) {
      return;
    }

    let axiosRequest = axios.create({
      baseURL: "api",
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      await axiosRequest.get("sim/migrateToInflux");
    } catch (e) {
      alert(e);
    }
  };

  AddSimGroupButton = () => (
    <Button icon="add" content={`Add Sim Group`} onClick={() => this.setState({ addSimGroup: true })} />
  );

  MigratoToInfluxButton = () => <Button content={`Migrate to Influx`} onClick={() => this.migrateToInflux()} />;

  render() {
    const { AddSimGroupButton, MigratoToInfluxButton } = this;
    const { addSimGroup } = this.state;
    const {
      store: { zoneId },
      history,
    } = this.props;

    return (
      <div>
        <div style={{ overflowY: "auto" }}>
          <Table unstackable collapsing>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell
                  onClick={() => this.setState({ shortId: !this.state.shortId })}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  ID
                </Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>
                  Bot<br />Id
                </Table.HeaderCell>
                <Table.HeaderCell>Exchange</Table.HeaderCell>
                <Table.HeaderCell>Type</Table.HeaderCell>
                <Table.HeaderCell>Period</Table.HeaderCell>
                <Table.HeaderCell>From</Table.HeaderCell>
                <Table.HeaderCell>To</Table.HeaderCell>
                <Table.HeaderCell>Created At</Table.HeaderCell>
                <Table.HeaderCell>Finished At</Table.HeaderCell>
                <Table.HeaderCell>Progress</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.state.simGroups &&
                this.state.simGroups.map(simGroup => (
                  <Table.Row
                    key={simGroup.id}
                    style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                    active={simGroup.id === this.state.selectedId}
                    onClick={() => history.push("/simGroup/" + simGroup.id)}
                  >
                    <Table.Cell>
                      <Button
                        basic
                        size="small"
                        icon="copy"
                        title="Copy"
                        onClick={e => {
                          this.setState({ addSimGroup: simGroup });
                          e.stopPropagation();
                        }}
                        disabled={Boolean(this.state.addSimGroup)}
                      />
                      <Button
                        basic
                        size="small"
                        icon="delete"
                        title="Delete"
                        onClick={e => {
                          this.delete(simGroup);
                          e.stopPropagation();
                        }}
                        disabled={Boolean(this.state.addSimGroup)}
                      />
                    </Table.Cell>
                    <Table.Cell title={simGroup.id}>
                      {this.state.shortId ? simGroup.id.substring(0, 4) : simGroup.id}
                    </Table.Cell>
                    <Table.Cell>
                      <strong>{simGroup.name}</strong>
                    </Table.Cell>
                    <Table.Cell title={simGroup.botId}>
                      {simGroup.botId && (this.state.shortId ? simGroup.botId.substring(0, 4) : simGroup.botId)}
                    </Table.Cell>
                    <Table.Cell>{simGroup.exchange}</Table.Cell>
                    <Table.Cell>{simGroup.type}</Table.Cell>
                    <Table.Cell>{simGroup.period}</Table.Cell>
                    <Table.Cell>{formatDateFromApi(simGroup.fromDate, zoneId)}</Table.Cell>
                    <Table.Cell>{formatDateFromApi(simGroup.toDate, zoneId)}</Table.Cell>
                    <Table.Cell>{formatDateTimeFromApi(simGroup.createdAt, zoneId)}</Table.Cell>
                    <Table.Cell>{formatDateTimeFromApi(simGroup.finishedAt, zoneId)}</Table.Cell>
                    <Table.Cell>
                      <small>{simGroup.progress}</small>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
        <Button.Group>
          <Button content="Refresh" icon="refresh" onClick={this.load} loading={this.state.loading} />
        </Button.Group>
        &nbsp;
        {!addSimGroup && (
          <Fragment>
            <AddSimGroupButton />
            <MigratoToInfluxButton />
          </Fragment>
        )}
        {addSimGroup && (
          <AddSimGroup
            onSuccess={() => {
              this.setState({ addSimGroup: null });
              this.load();
              toast.info("Sim started");
            }}
            base={this.state.addSimGroup !== true ? this.state.addSimGroup : null}
            onClose={() => this.setState({ addSimGroup: null })}
          />
        )}
      </div>
    );
  }
}

export default SimGroups;



// WEBPACK FOOTER //
// ./src/sim/SimGroups.js